import { render, staticRenderFns } from "./RevivedNumbersPreview.vue?vue&type=template&id=053692c4&lang=pug&"
import script from "./RevivedNumbersPreview.vue?vue&type=script&lang=js&"
export * from "./RevivedNumbersPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports